<div class="row pt-2 pb-2">
    <div class="col-sm-9">
        <h4 class="page-title">Manage Officers</h4>
    </div>
    <div class="col-sm-3">
        <div class="btn-group float-sm-right">
            <button type="button" (click)="ClearForm()" data-toggle="modal" data-target="#officer_modal" class="btn btn-outline add_btn btn-sm">
                <i class="zmdi zmdi-plus mr-1"></i>Add Officer
            </button>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <!-- <h5 class="card-title">Responsive Table</h5> -->
                 <div class="row mb-3">

                    <div class="col-md-2">
                        <ng-select
                            [items]="filterPositionList"
                            bindLabel="name"
                            bindValue="id"
                            placeholder="Position"
                            [(ngModel)]="filterObj.position"
                            (change)="applyFilter()">
                        </ng-select>
                    </div>

                    <div class="col-md-2">
                        <ng-select
                            [items]="filterTypeList"
                            bindLabel="name"
                            bindValue="id"
                            placeholder="Type"
                            [(ngModel)]="filterObj.position_type"
                            (change)="applyFilter()">
                        </ng-select>
                    </div>

                    <div class="col-md-2">
                        <ng-select
                            [items]="filterShiftList"
                            bindLabel="name"
                            bindValue="id"
                            placeholder="Shift"
                            [(ngModel)]="filterObj.shift"
                            (change)="applyFilter()">
                        </ng-select>
                    </div>
                    <div class="col-md-2">
                        <ng-select
                            [items]="filterZoneList"
                            bindLabel="zone_name"
                            bindValue="id"
                            [multiple]="true"
                            name="filter_zone_name"
                            placeholder="Select Zone"
                            [(ngModel)]="filterObj.zone_ids"
                            (change)="onFilterZoneChange()">
                        </ng-select>
                    </div>
                    
                    <div class="col-md-2">
                        <ng-select
                            [items]="filterWardList"
                            bindLabel="ward_name"
                            bindValue="id"
                            [multiple]="true"
                            placeholder="Select Ward"
                            [(ngModel)]="filterObj.ward_ids"
                            (change)="applyFilter()">
                        </ng-select>
                    </div>
                    
                    <!-- <div class="col-md-2">
                        <button
                            class="btn btn-danger btn-block"
                            (click)="clearFilter()">
                            Clear
                        </button>
                    </div> -->

                </div>
                <div class="table-responsive">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-bordered table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Officer Name</th>
                                <th>Mobile No.</th>
                                <th>Position</th>
                                <th>Type</th>
                                <th>Shift</th>
                                <th style="white-space: normal;">Address</th>
                                <th>Zone</th>
                                <th>Ward</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            
                            <tr *ngFor="let oData of officerRowdata; let i = index">
                                <td>{{i+1}}</td>
                                <td>{{oData.full_name}}</td>
                                <td>{{oData.mobile_no}}</td>
                                <td>{{oData.position}}</td>
                                <td>{{oData.position_type}}</td>
                                <td>{{oData.shift}}</td>
                                <td>{{oData.address}}</td>
                                <td>{{oData.zone_id}}</td>
                                <td>{{oData.ward_id}}</td>
                                <td style="text-align: center;">
                                    <a data-toggle="modal" data-target="#officer_modal" (click)="EditOfficer(oData.officer_id)" style="color: dodgerblue">
                                        <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>      
                                    </a><span style="margin-left: 15px;"></span>
                                    <a (click)="DeleteOfficer(oData.officer_id)" style="color: red;">
                                        <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                                    </a>                               
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    
                </div>
            </div>
        </div>
    </div>
</div>
<div class="loader-wrapper" id="loading" *ngIf="isLoading" >
    <div class="loader-card">
        <div class="spinner">
            <div class="spinner-ring"></div>
            <div class="spinner-ring delay"></div>
            <div class="core"></div>
        </div>
    </div>
</div>
<div id="officer_modal" class="modal fade hide" role="dialog">
    <form action="#" #officerMasterForm="ngForm">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title">Officer Details</h6>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="form-row">
                        <input type="hidden" id="officer_id" name="devId" [(ngModel)]="officerForm.officer_id">

                        <div class="form-group col-12 col-md-4">
                            <label for="full_name">Officer Name</label>
                            <input type="text" id="full_name" name="full_name" [(ngModel)]="officerForm.full_name"
                                class="form-control form-control-sm"  required>
                        </div>
    
                        <div class="form-group col-12 col-md-4">
                            <label for="mobile_no">Mobile No.</label>
                            <input type="text" id="mobile_no" name="mobile_no" [(ngModel)]="officerForm.mobile_no"
                                class="form-control form-control-sm" required>
                        </div>
    
                        <div class="form-group col-12 col-md-4">
                            <label for="email">Email</label>
                            <input type="text" id="email" name="email" [(ngModel)]="officerForm.email"
                                class="form-control form-control-sm" required>
                        </div>
    
                        <!-- <div class="form-group col-12 col-md-4">
                            <label for="position">Position</label>
                            <input type="text" id="position" name="position"
                                [(ngModel)]="officerForm.position" class="form-control" required>
                        </div> -->

                        <div class="form-group col-12 col-md-4">
                            <label>Position</label>
                            <ng-select
                                [items]="positionList"
                                bindLabel="name"
                                bindValue="id"
                                placeholder="Select Position"
                                name="position"
                                [(ngModel)]="officerForm.position"
                                required>
                            </ng-select>
                        </div>
    
                        <!-- <div class="form-group col-12 col-md-4">
                            <label for="position_type">Position Type</label>
                            <input type="text" id="position_type" name="position_type" [(ngModel)]="officerForm.position_type"
                                class="form-control" required>
                        </div> -->

                        <div class="form-group col-12 col-md-4">
                            <label>Position Type</label>
                            <ng-select
                                [items]="positionTypeList"
                                bindLabel="name"
                                bindValue="id"
                                placeholder="Select Position Type"
                                name="position_type"
                                [(ngModel)]="officerForm.position_type"
                                required>
                            </ng-select>
                        </div>
                        
                        <!-- <div class="form-group col-12 col-md-4">
                            <label for="shift">Shift</label>
                            <input type="text" id="shift" name="shift" [(ngModel)]="officerForm.shift"
                                class="form-control" required>
                        </div> -->

                        <div class="form-group col-12 col-md-4">
                            <label>Shift</label>
                            <ng-select
                                [items]="shiftList"
                                bindLabel="name"
                                bindValue="id"
                                placeholder="Select Shift"
                                name="shift"
                                [(ngModel)]="officerForm.shift"
                                required>
                            </ng-select>
                        </div>

                        <div class="form-group col-12 col-md-4">
                            <label for="address">Address</label>
                            <input type="text" id="address" name="address" [(ngModel)]="officerForm.address"
                                class="form-control form-control-sm" required>
                        </div>

                        <div class="form-group col-12 col-md-4">
                            <label for="longitude">Zone</label>
                            <ng-select [items]="zoneDataArr" bindLabel="zone_name" bindValue="id"
                                placeholder="Select Zone" appendTo="body" name="zone_name"
                                [multiple]="true"
                                (change)="GetZoneName($event.id)"
                                id="zone_id"
                                [(ngModel)]="officerForm.zone_id">
                            </ng-select>
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="longitude">Ward</label>
                            <ng-select [items]="wardDataArr" bindLabel="ward_name" bindValue="id"
                                placeholder="Select Ward" appendTo="body" name="ward_name"
                                id="ward_id"
                                [multiple]="true"
                                [(ngModel)]="officerForm.ward_id">
                            </ng-select>
                        </div>
    
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="reset" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                    <button type="submit" class="btn btn-primary" (click)="onSubmit()">
                        {{ isEditMode ? 'Update' : 'Save' }}</button>
                </div>
            </div>
        </div>
    </form>
</div>